export const initOnce = (selector, app) => {
    [...document.querySelectorAll(selector)]
    .filter(instans => !instans.inited)
    .forEach(instans => {
        instans.inited = true;
        app(instans);
    });
};